import { useEffect, useState } from "react";
import { BOOKING_URL } from "../data/site";

// Owner-managed Vagaro links per service (set in the private inbox). Fetched once and shared.
let cache = null;
let pending = null;
const load = () => {
  if (!pending) {
    pending = fetch(`${process.env.REACT_APP_BACKEND_URL}/api/booking-links`)
      .then((r) => (r.ok ? r.json() : {}))
      .catch(() => ({}))
      .then((d) => { cache = d && typeof d === "object" ? d : {}; return cache; });
  }
  return pending;
};

export const useBookingLinks = () => {
  const [links, setLinks] = useState(cache || {});
  useEffect(() => {
    let live = true;
    load().then((d) => { if (live) setLinks(d); });
    return () => { live = false; };
  }, []);
  return links;
};

export const useBookingLink = (service) => useBookingLinks()[service] || BOOKING_URL;
export const resetBookingLinks = () => { cache = null; pending = null; };
